import React, { useState, useRef, useEffect, useMemo } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import TextInput from "../../Global Functions/textInput";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getCountryList } from "../../Redux/Actions/countryAction";
import AddImage from "../../Global Functions/addImage";
import { formatKey } from "../../Utils/helpers";
import ConsultantIcon from "../../Assets/Consultant/ConsultantIcon";
import SelectInput from "../../Global Functions/selectInput";
import { addConsultant, consultantList } from "../../Redux/Actions/consultantAction";
import './Consultant.css';
import ConsultantConstant from "./ConstultantConstant";
import { viewPlanList } from "../../Redux/Actions/subscriptionActions";
const AddConsultant = () => {
  const [consultantData, setConsultantData] = useState({
    first_Name: "",
    last_Name: "",
    email: "",
    rera_id: "",
    phone: "",
    select_experience_range: "",
    state: "",
    city: "",
    rera_document: "",
    pan_document: "",
    profile: "",
    bio: "",
    current_plan: ""
  });
  const countryData = useSelector((state) => state.country);
  const [country_code, setCountry_code] = useState();
  const countryOptions = useMemo(() => {
    return countryData.countryList?.data[0]?.states
      ? countryData.countryList.data[0].states
      : [];
  }, [countryData]);
  const prevDialCodeRef = useRef(null);
  const [availableCities, setAvailableCities] = useState();
  const [imagePreviews, setImagePreviews] = useState({
    rera_document: null,
    pan_document: null,
    profile: null,
  });

  const disabledField = ["country", "state", "city"];
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const planList = useSelector((state) => state.subscription)

  const consultantPlanOptions = planList?.plan?.data?.map(plan => ({
    label: plan.plan_name,
    value: plan._id
  })) || [];


  const handleChange = async (e) => {
    const { name, value, files } = e.target;
    if (name === "current_plan") {
      const selectedPlan = planList.plan.data.find(p => p._id === value);
      setConsultantData(prev => ({
        ...prev,
        [name]: selectedPlan,
      }));
      return;
    }
    if (name === "state") {
      const cities = countryOptions.find((val) => val._id === value)?.cities;
      setAvailableCities(cities);
    } else if (
      name === "pan_document" ||
      name === "profile" ||
      name === "rera_document"
    ) {
      const file = files && files[0];
      if (!file) return;
      const res = await AddImage(files[0]);
      if (res) {
        setImagePreviews((prev) => ({
          ...prev,
          [name]: res,
        }));
        setConsultantData({ ...consultantData, [name]: res });
        return
      }
    }

    setConsultantData({ ...consultantData, [name]: value });
  };

  const experienceOptions = [
    { label: "1-3", value: "1-3" },
    { label: "3-5", value: "3-5" },
    { label: "5-7", value: "5-7" },
    { label: "7-10", value: "7-10" },
    { label: "10+", value: "10+" },
  ];

  useEffect(() => {
    const payload = {
      "page": 1,
      "limit": 10,
      "status": ["active", "inactive"]
    }
    dispatch(viewPlanList(payload))
  }, [dispatch])



  const handleSave = () => {
    const data = {
      first_name: consultantData.first_Name,
      last_name: consultantData.last_Name,
      email: consultantData.email,
      country_code: country_code,
      contact_number: consultantData.phone,
      city: consultantData.city,
      state: consultantData.state,
      rera_id: consultantData.rera_id,
      rera_certificate_url: consultantData.rera_document,
      pan_image_url: consultantData.pan_document,
      experience: consultantData.select_experience_range,
      bio: consultantData.bio,
      profile_image: consultantData.profile,
      current_plan: consultantData.current_plan
    }
    dispatch(addConsultant(data));
    Navigate("/Consultants");
  };
  const handleCancel = () => {
    Navigate("/Consultants");
  };
  const handleChangeContact = (code, number) => {
    const fullPhone = `${code}${number}`;

    setConsultantData((prev) => ({
      ...prev,
      phone: fullPhone,
    }));
  };

  const disabled = useMemo(() => {
    return countryOptions.length < 1 ? true : false;
  }, [countryOptions]);
  useEffect(() => {
    dispatch(getCountryList({ country_code: country_code }));
  }, [country_code, dispatch]);

  return (
    <MainLayout>
      <div className="custom-popup main-consultant">
        <div className="popup-header popup-new">
          <div className="top_bar">
            <div className="child_header addConsultant_class">
              <ConsultantIcon />
              <span className="add-consultant">Add Consultant</span>
              {/*  add all constants in a constants file */}
            </div>
            <div>
              <div>
                <button
                  className="route_btn"
                  onClick={() => Navigate("/Consultants")}
                >
                  {ConsultantConstant.VIEW_CONSULTANT_LIST}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="popup_body">
          {Object.entries(consultantData).map(([key, val], i) => {
            if (key === "phone") {
              return (
                <div className="phone-number">
                  <label
                    for={"phone"}
                    className="text-[14px]/6 text-black md:text-white"
                  >
                    {formatKey(key)}
                  </label>
                  <PhoneInput
                    id={"phone"}
                    country={"in"}
                    name={"Phone"}
                    ref={prevDialCodeRef}
                    value={val}
                    onChange={(fullValue, countryData) => {
                      const newCountryCode = `+${countryData.dialCode}`;
                      const newContactNumber = fullValue.slice(
                        countryData.dialCode.length
                      );

                      handleChangeContact(newCountryCode, newContactNumber);

                      if (prevDialCodeRef.current !== newCountryCode) {
                        prevDialCodeRef.current = newCountryCode;
                        setCountry_code(newCountryCode);
                      }
                    }}
                    inputProps={{ name: "contactNumber", required: true }}
                    containerClass="custom-container"
                    inputClass=" custom-input"
                    buttonClass="custom-button"
                    dropdownClass="custom-dropdown"
                    inputStyle={{ border: "none" }}
                  />
                </div>
              );
            } else if (
              key === "pan_document" ||
              key === "profile" ||
              key === "rera_document"
            ) {
              return (
                <div
                  style={{ width: "40%" }}
                  className="consultant_doc"
                >
                  {" "}
                  <TextInput
                    disabled={disabledField.includes(key) ? true : false}
                    name={key}
                    label={formatKey(key)}
                    id={key}
                    type="file"
                    forImage={true}
                    onChange={handleChange}
                  />
                  {imagePreviews[key] && (
                    <div className="image-preview">
                      <img
                        src={imagePreviews[key]}
                        alt={`${key} preview`}
                        style={{ width: "100px", height: "100px", marginTop: "10px", objectFit: "cover" }}
                      />
                    </div>
                  )}
                </div>
              );
            } else if (key === "state" || key === "city") {
              return (
                <div style={{ width: "40%" }} className="plan_custom_select">
                  <SelectInput
                    placeholder={
                      key === "state" ? "Enter Your State" : "Enter Your City"
                    }
                    disabled={disabled}
                    label={formatKey(key)}
                    name={key}
                    id={key}
                    value={
                      key === "state"
                        ? consultantData.state
                        : consultantData.city
                    }
                    options={
                      key === "state"
                        ? countryOptions?.map((val) => ({
                          label: val.state_name,
                          value: val._id,
                        }))
                        : availableCities?.map((val) => ({
                          label: val.city_name,
                          value: val._id,
                        }))
                    }
                    onChange={handleChange}
                  />
                </div>
              );
            }
            // else if( )
            else if (key === "select_experience_range") {
              return (
                <div style={{ width: "40%" }} className="plan_custom_select">
                  <SelectInput
                    name={key}
                    label={formatKey(key)}
                    value={val}
                    onChange={handleChange}
                    options={experienceOptions}
                    placeholder="Select Experience Range"
                  />
                </div>
              );
            }
            else if (key === "bio") {
              return (
                <div style={{ width: "40%" }}>
                  <TextInput
                    name={key}
                    label={formatKey(key)}
                    value={val}
                    onChange={handleChange}
                    type="textarea"
                    placeholder={ConsultantConstant.ENTER_YOUR_BIO}
                    row={10}
                  />
                </div>
              );
            }
            else if (key === "current_plan") {
              return (
                <div style={{ width: "40%" }} className="plan_custom_select">
                  <SelectInput
                    name={key}
                    label={formatKey(key)}
                    value={val?._id || ""}
                    onChange={handleChange}
                    options={consultantPlanOptions}
                    placeholder="Select Consultant Plan"
                  />
                </div>
              );
            }

            else {
              return (
                <div style={{ width: "40%" }}>
                  <TextInput
                    name={key}
                    label={formatKey(key)}
                    value={val}
                    onChange={handleChange}
                  />
                </div>
              );
            }
          })}
        </div>
        <div className="popup-footer consultant-footer">
          <div>
            <button onClick={handleCancel}>{ConsultantConstant.CANCEL}</button>
          </div>
          <div>
            <button onClick={handleSave}>{ConsultantConstant.SAVE}</button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddConsultant;
